/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowsLeftDown = createReactComponent("arrows-left-down", "IconArrowsLeftDown", [
  ["path", { d: "M7 3l-4 4l4 4", key: "svg-0" }],
  ["path", { d: "M3 7h11a3 3 0 0 1 3 3v11", key: "svg-1" }],
  ["path", { d: "M13 17l4 4l4 -4", key: "svg-2" }]
]);

export { IconArrowsLeftDown as default };
//# sourceMappingURL=IconArrowsLeftDown.js.map
